import React, { useEffect } from 'react';
import { Card, Button, Form } from 'react-bootstrap';
import { useNavigate, Link } from 'react-router-dom';
import EditDeleteBtn from '~/components/EditDeleteBtn';
import {
    fetchCharacterClassCardApi,
    deleteCharacterClassCardItemApi,
    toggleCharacterClassCardPublishedStateApi,
} from './characterClassCardSlice';
import { useSelector, useDispatch } from 'react-redux';
import Datatable from '~/components/Datatable';
import { titleCase } from '~/utils/helpers';

function CharacterClass() {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { rows } = useSelector((state) => state.cardSaga.characterClassCard);
    const columns = React.useMemo(
        () => [
            {
                name: '#',
                selector: (row) => row.id,
                sortable: true,
            },
            {
                name: 'Name',
                selector: (row) => titleCase(row.name),
                sortable: true,
            },
            {
                name: 'Edit/Remove',
                cell: (row) => (
                    <EditDeleteBtn
                        row={row}
                        thunkFunc={deleteCharacterClassCardItemApi}
                    />
                ),
            },
            {
                name: 'Published',
                cell: (row) => (
                    <Form.Check
                        type="switch"
                        id={'published-' + row.id}
                        onChange={() => {
                            dispatch(toggleCharacterClassCardPublishedStateApi(row.id));
                        }}
                        checked={row.is_ready}
                    />
                ),
            },
        ],
        [],
    );

    useEffect(() => {
        if (rows.length > 0) return;

        dispatch(fetchCharacterClassCardApi(navigate));
    }, []);

    return (
        <Card>
            <Card.Body>
                <div className={'d-flex flex-row-reverse'}>
                    <Link to={'create'}>
                        <Button className={'bg-info border border-info'}>Create</Button>
                    </Link>
                </div>
                <div className="col-sm-6 offset-sm-3">
                    <Datatable
                        columns={columns}
                        rows={rows}
                    />
                </div>
            </Card.Body>
        </Card>
    );
}

export default CharacterClass;
